import type { ImageDimensions } from '@eliadmin/core/src/utils/image-dimensions';

// Verified source-asset dimensions, 2026-10-11. Metadata from the API takes precedence.
export const BANNER_IMAGE_CONFIG: { dimensions: Readonly<Record<string, ImageDimensions>> } = {
  dimensions: {
    "https://api.oszlopok.hu/files/banner-hu-JWtCSBEefV1UtgrhvMN7NEej0u2izb64YyHjEZ0z.png?ai=0": {
      "width": 2880,
      "height": 1000
    },
    "https://api.oszlopok.hu/files/foQSalNCXs9tDEFeSGzzuQwpEWiqmTGcZHhAIbv0.png?ai=0": {
      "width": 1248,
      "height": 600
    },
    "https://api.oszlopok.hu/files/0oY0rggDkNo1BbA5dCZx1FK5GJOhdh75Vef3lzT5.png?ai=0": {
      "width": 684,
      "height": 330
    },
    "https://api.oszlopok.hu/files/mobile-banner-HJqsnguVwDTApTBjkSBINJaK71ZtSgZTLxS1NnaP.png?ai=0": {
      "width": 780,
      "height": 1000
    }
  },
};

